import React, { useState, createContext, useEffect } from "react";
import { useSelector } from "./../redux/store";

export const CompareContext = createContext();

export const CompareListProvider = (props) => {
  const { compareForContextData } = useSelector((state) => state.user);
  const [compareList, setCompareList] = useState([]);

  useEffect(() => {
    setCompareList(compareList);
  }, [compareList]);

  return (
    <CompareContext.Provider value={[compareList, setCompareList]}>
      {props.children}
    </CompareContext.Provider>
  );
};
